import React, { useMemo } from "react";
import { Text } from "@mantine/core";

import { useRoomTypesContext } from "@/contexts";

export interface RoomTypeBadgeProps {
  /** Currently selected room type ID */
  value?: string | null | undefined;
  /** Size of the selector */
  size?: "xs" | "sm" | "md" | "lg" | "xl";
}

export const RoomTypeBadge: React.FC<RoomTypeBadgeProps> = ({
  value,
  size = "sm",
}) => {
  const { roomTypes, loading } = useRoomTypesContext();

  // Filter and prepare room type options
  const roomTypeName = useMemo(() => {
    let typeName = "";

    if (roomTypes?.length) {
      const roomType = roomTypes.find(
        (roomType: any) => roomType?.id === value
      );

      if (roomType) {
        typeName = roomType.name ?? "";
      }
    }

    if (!typeName) {
      return `Unknown (${value})`;
    }

    return typeName;
  }, [roomTypes, loading, value]);

  // Render the select component
  return <Text size={size}>{roomTypeName}</Text>;
};
